module.exports = __webpack_public_path__ + "img/voice-icon12.61f9e76.png";